import WsService from "../../WsService";
import CardBatchResponse from "../../../domain/card/batch/CardBatchResponse";
import CardBatch from "../../../domain/card/batch/CardBatch";
import BankCardUserAssignmentRequest from "../../../domain/card/batch/BankCardUserAssignmentRequest";
import RawWsService from "../../RawWsService";

const ENDPOINT_BASE = "/admin/card-batch";

export default class CardBatchService {

    static retrieve(id) {

        let endpoint = ENDPOINT_BASE + "/" + id;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new CardBatchResponse(response);
            },
            response => {
                return response;
            });
    }

    static assignCardsToUser(batchId, bankCardUserAssignmentRequest) {

        let endpoint = ENDPOINT_BASE + "/" + batchId + "/assign-cards-to-user";
        let jsonObj = BankCardUserAssignmentRequest.toJson(bankCardUserAssignmentRequest);

        return WsService.put(endpoint, jsonObj, 200).then(
            response => {
                return new CardBatchResponse(response);
            },
            response => {
                return response;
            });
    }

    static retrieveAssignedBatchesForUser(search = "", headers) {
        let endpoint = ENDPOINT_BASE + "/assigned?search=" + search;

        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            rawResponse => {
                let response = rawResponse.body;
                let results = [];
                response.forEach(jsonResponse => {
                        results.push(new CardBatch(jsonResponse));
                    }
                );
                return {"headers": rawResponse.headers, "body": results};
            },
            response => {
                return response;
            });
    }
}
